"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createConfigProvider = exports.configProvider = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const configProvider = (Context) => {
    const Provider = ({ children, config, }) => {
        const [api /* setApi */] = (0, react_1.useState)(config.api);
        const handleApiChange = (code) => {
            // console.log(code);
        };
        return ((0, jsx_runtime_1.jsx)(Context.Provider, { value: {
                ...config,
                api,
                changeApi: handleApiChange,
            }, children: children }, void 0));
    };
    return Provider;
};
exports.configProvider = configProvider;
const createConfigProvider = (context) => (0, exports.configProvider)(context);
exports.createConfigProvider = createConfigProvider;
